import { render } from "./FamilySection.vue?vue&type=template&id=cad508a6&scoped=true"
import script from "./FamilySection.vue?vue&type=script&lang=js"
export * from "./FamilySection.vue?vue&type=script&lang=js"

import "./FamilySection.vue?vue&type=style&index=0&id=cad508a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad508a6"]])

export default __exports__